import * as React from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NavLinkButton, Table } from '@shared/components/bootstrap';
import { UserRole } from '@shared/types/user_role';

import { Panel } from '@admin/components/helpers/panel';
import { createVehicleTypeURL, editVehicleTypeURL } from '@admin/config/routes';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useVehicleTypesQuery } from '@admin/schema';

import { Roles } from '../helpers/roles';

export const VehicleTypes: React.FC = () => {
  useTitle('Vehicle Types');
  const { data } = useVehicleTypesQuery({ client });

  if (!data || !data.vehicleTypes) {
    return null;
  }

  return (
    <Panel>
      <Panel.Header>
        <Panel.Title>Vehicle Types</Panel.Title>
      </Panel.Header>
      <Panel.Body>
        <Table striped responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Cuft</th>
              <th>Number of Seats</th>
              <th>Weight in Pounds</th>
              <th>Length (in)</th>
              <th>Width (in)</th>
              <th>Height (in)</th>
              <th>Field Dispatchable</th>
              <th className="col-md-3">Restricted Zip Codes</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.vehicleTypes.map((type) => (
              <tr key={type.id}>
                <td>{type.name}</td>
                <td>{type.cuft}</td>
                <td>{type.numSeats}</td>
                <td>{type.weightInPounds}</td>
                <td>{type.lengthInInches}</td>
                <td>{type.widthInInches}</td>
                <td>{type.heightInInches}</td>
                <td>{type.fieldDispatchable ? 'True' : 'False'}</td>
                <td className="col-md-3">{type.restrictedZipCodes.join(', ')}</td>
                <td>
                  <a className="btn btn-primary" href={editVehicleTypeURL({ id: type.id })}>
                    Edit
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Panel.Body>
      <Roles show={[UserRole.Admin]}>
        <Panel.Footer align="right">
          <NavLinkButton to={createVehicleTypeURL()} kind="mint">
            <FontAwesomeIcon icon={faPlus} /> Add new
          </NavLinkButton>
        </Panel.Footer>
      </Roles>
    </Panel>
  );
};
